


<app-modal-header
  (close)="close()">
  <span slot="title">{{ 'admin.session-card-modal.hour-rate-modal.title' | translate }}</span>
</app-modal-header>

<div class="modal-body">
  <app-hour-rate-fg [fg]="internalFG" [appendTo]="null"></app-hour-rate-fg>
</div>

<div class="modal-footer">
  <button
    pButton
    (click)="onSubmit()"
    label="{{ 'admin.session-card-modal.hour-rate-modal.submit-btn-label' | translate }}">
  </button>
</div>